const getters = {
  getTransportResourceDetails: (state) => {
    return state.transportRequest !== null ? state.transportRequest : null
  },
  getTransportVehicleEquipment: (state) => (
    state.transportEnums.vehicleEquipment != null ? state.transportEnums.vehicleEquipment : []
  ),
  getTransportCargoRestrictions: (state) => (
    state.transportEnums.cargoRestrictions != null ? state.transportEnums.cargoRestrictions : []
  ),
  getTransportLocationEquipment: (state) => (
    state.transportEnums.locationEquipment != null ? state.transportEnums.locationEquipment : []
  ),
  getTransportCreatingShipmentState: (state) => (state.createdShipment)
}

export default getters
